import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../services/split-service.service";

export class BringozTagCtrl implements IController {

  name: string;
  color: any;
  description:string;

  private options: any;

  /* @ngInject */
  constructor(private splitService: SplitService) {

  }

  $onInit() {
    this.options = this.splitService.getIsSite() ? this.splitService.getSiteSkills() : [];

    if (!this.color) {
      const tag = _.find(this.options, (o) => {
        return o.name === this.name;
      })

      if (!!tag) {
        this.color = tag.color;
      }
    }
  }

  $onChanges(changes) {
    if (changes.name && !changes.name.isFirstChange() || changes.color && !changes.color.isFirstChange()) {
      this.$onInit();
    }
  };


}
angular
  .module('bringoz.admin.commons')
  .component('bringozTag', {
    bindings : {
      name: '<',
      color: '<?',
      description: '<?',
    },
    template: require('./bringoz-tag.html').default,
    controller: BringozTagCtrl
  });

